module.exports = __webpack_public_path__ + "static/media/bestof_6.2ce3c9b5.jpg";